import { Typography } from '@bowtie-ins/bowkit';
import { WHITE } from '@bowtie-ins/bowkit/palette';
import { Box, alpha } from '@material-ui/core';
import { ReactNode, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

const SEMI_TRANSPARENT = alpha(WHITE, 0.1);

type UnitCounterProps = {
  count: number;
  unit: ReactNode;
};

const UnitCounter = ({ unit, count }: UnitCounterProps) => {
  const formattedCount = useMemo(
    () =>
      new Intl.NumberFormat('en', {
        minimumIntegerDigits: 2,
      }).format(count),
    [count],
  );

  return (
    <Box display="flex" alignItems="flex-end" gridGap={4} color={WHITE}>
      <Box
        bgcolor={SEMI_TRANSPARENT}
        width={26}
        height={26}
        borderRadius={4}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="title-xs">{formattedCount}</Typography>
      </Box>
      <Typography variant="body-s">{unit}</Typography>
    </Box>
  );
};

type CounterProps = {
  seconds: number;
  minutes: number;
  hours: number;
  days: number;
};

const Counter = ({
  days = 0,
  hours = 0,
  minutes = 0,
  seconds = 0,
}: CounterProps) => {
  return (
    <Box display="flex" gridGap={10}>
      <UnitCounter count={days} unit={<FormattedMessage id="counter.day" />} />
      <UnitCounter
        count={hours}
        unit={<FormattedMessage id="counter.hour" />}
      />
      <UnitCounter
        count={minutes}
        unit={<FormattedMessage id="counter.minute" />}
      />
      <UnitCounter
        count={seconds}
        unit={<FormattedMessage id="counter.second" />}
      />
    </Box>
  );
};

export default Counter;
